// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"89a98e28","732":"73478a5e"}[chunkId] + ".chunk.js";
};